import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  cssVariables: true,
  palette: {
    action: {
      active: '#303240',
    },
    primary: {
      main: '#0A68F1',
    },
    secondary: {
      main: '#474A59',
    },
    error: {
      main: '#FF4242',
    },
    text: {
      primary: '#303240',
      secondary: '#6C6F80',

    },
    background: {
      default: '#f5f6fa',
    },
  },
  typography: {
    fontFamily: [
      'SourceSansPro',
      'MuseoSans',
      'sans-serif',
    ].join(','),
    h3: {
      fontSize: 42,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 448,
      md: 768,
      lg: 992,
      xl: 1439
    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected .MuiListItemIcon-root': {
            color: '#303240',
            '& svg': {
              fill: '#303240'
            }
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: '#6C6F80',
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          color: '#474A59',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          verticalAlign: 'unset'
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: ['0px 0px 3px 0px rgba(29, 30, 38, 0.05)',
                      '0px 3px 6px 0px rgba(29, 30, 38, 0.1)'],
          borderRadius: '6px'            
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: ['0px 0px 3px 0px rgba(29, 30, 38, 0.05)',
                      '0px 3px 6px 0px rgba(29, 30, 38, 0.1)'],
          borderRadius: '6px'            
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          width: '100%',
          maxWidth: '360px'
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: '3px',
          borderColor: '#CED0DB'
        },
        notchedOutline: {
          borderRadius: '3px',
          borderColor: '#CED0DB'
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          top: '-24px',
          fontSize: 14,
          fontWeight: 600,
          color: '#111111',
          transform: 'none'
        },
        asterisk: {
          color: '#FF4242',
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        title: {
          fontSize: '18px',
          fontWeight: 600
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      }
    }
  },
});

export default theme;